import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable} from 'rxjs';
import { take } from 'rxjs/operators';
import { NiceLegalTextComponent } from './nice-legal-text.component';

@Injectable()
export class NiceLegalTextModalService {

  constructor(
    private modal: BsModalService,
  ) { }

  open(type:'personal-info'|'third-party-info'|'social-security-info'):Observable<boolean> {
    const modal:BsModalRef = this.modal.show(NiceLegalTextComponent, {initialState:{type}}); 
    return modal.content.action.pipe(take(1))
  }

}
